import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SnackbarComponent } from './commonComponents/snackbar/snackbar.component';
import { NetworkCheckComponent } from './commonComponents/network-check/network-check.component';
import { BottomSheetOverviewExampleSheet } from './commonComponents/network-check/network-check.component';
import { LoaderComponent } from './commonComponents/loader/loader.component';

@NgModule({
    imports: [CommonModule],
    declarations: [SnackbarComponent, NetworkCheckComponent, BottomSheetOverviewExampleSheet],
    exports: [SnackbarComponent],
    entryComponents: [
        NetworkCheckComponent,
        BottomSheetOverviewExampleSheet,
        
    ],
})
export class SharedComponentModule { }